export const TASK_PRIORITY = {
  URGENT: 1,
  HIGH: 2,
  MEDIUM: 3,
  LOW: 4,
};

export const TASK_PRIORITY_OPTIONS = [
  { value: TASK_PRIORITY.URGENT, label: "Urgente" },
  { value: TASK_PRIORITY.HIGH, label: "Alta" },
  { value: TASK_PRIORITY.MEDIUM, label: "Media" },
  { value: TASK_PRIORITY.LOW, label: "Baixa" },
];

export const normalizeTaskPriority = (value, fallback = TASK_PRIORITY.MEDIUM) => {
  const priority = Number(value);
  return [1, 2, 3, 4].includes(priority) ? priority : fallback;
};

export const getTaskPriorityLabel = (value) => {
  const priority = normalizeTaskPriority(value, null);
  const option = TASK_PRIORITY_OPTIONS.find((item) => item.value === priority);
  return option?.label || "Sem prioridade";
};

export const getTaskPriorityTone = (value) => {
  const priority = normalizeTaskPriority(value, null);
  if (priority === TASK_PRIORITY.URGENT) return "danger";
  if (priority === TASK_PRIORITY.HIGH) return "warning";
  if (priority === TASK_PRIORITY.MEDIUM) return "info";
  if (priority === TASK_PRIORITY.LOW) return "secondary";
  return "secondary";
};

export const getTaskPriorityClass = (value) => {
  const priority = normalizeTaskPriority(value, null);
  if (priority === TASK_PRIORITY.URGENT) return "urgent";
  if (priority === TASK_PRIORITY.HIGH) return "high";
  if (priority === TASK_PRIORITY.MEDIUM) return "medium";
  if (priority === TASK_PRIORITY.LOW) return "low";
  return "none";
};

export const compareTaskPriority = (left, right) =>
  normalizeTaskPriority(left?.prioridade, 99) - normalizeTaskPriority(right?.prioridade, 99);
